import { History } from "history";
import { BEGIN_LOGIN, END_LOGIN_SUCCESS, END_LOGIN_ERROR, LOGOUT, Account } from "./types";
import { AppDispatch } from "../store";
import * as routes from "../../routes";
import createMsalInstance, {
    isRedirected,
    logout,
    loginPopup,
    loginRedirect,
    getAccount
} from "../../services/msalService";
import { resetInactivityTimer } from "../../services/inactivityTimer";

const beginLogin = () => ({ type: BEGIN_LOGIN });

const endLoginSuccess = (account?: Account | null) => ({ type: END_LOGIN_SUCCESS, account });

const endLoginError = (error: string) => ({ type: END_LOGIN_ERROR, error });

export type Callback = () => void;

const signOutCallbacks: Callback[] = [];

export const addSignOutCallback = (callback: Callback) => {
    if (signOutCallbacks.indexOf(callback) < 0) {
        signOutCallbacks.push(callback);
    }
};

export const removeSignOutCallback = (callback: Callback) => {
    let index: number;
    if ((index = signOutCallbacks.indexOf(callback)) >= 0) {
        signOutCallbacks.splice(index, 1);
    }
};

export const signIn = (history: History) => {
    if (isRedirected()) {
        loginRedirect();
        return beginLogin();
    }

    return async (dispatch: AppDispatch) => {
        // save and restore the location and login when on the redirect URL path, otherwise Azure will not validate
        const location = history.location;
        history.replace({ pathname: routes.DEFAULT });
        dispatch(beginLogin());
        try {
            const response = await loginPopup();
            dispatch(endLoginSuccess(response?.account));
            resetInactivityTimer(true);
        } catch (error) {
            dispatch(endLoginError(error));
        }
        history.replace(location);
    };
};

export const signOut = () => (dispatch: AppDispatch) => {
    try {
        logout();
    } catch (e) {
        console.error(`Error in logging out: ${e.errorMessage}`);
    }
    signOutCallbacks.forEach(c => c());
    dispatch({ type: LOGOUT });
};

export const initializeIdentityProvider = (clientId: string, authority: string) => (dispatch: AppDispatch) => {
    const authCallback = (error: string, response: any) => {
        if (error) {
            dispatch(endLoginError(error));
        } else if (response) {
            dispatch(endLoginSuccess(getAccount()));
            resetInactivityTimer(true);
        }
    };
    dispatch(beginLogin());
    createMsalInstance(clientId, authority, authCallback);
    dispatch(endLoginSuccess(getAccount()));
};
